import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import selectHelper from '../../../Helpers/selectHelper';
import LineItemTypeEnum from '../../../Enums/LineItemTypeEnum';
import OutsourcedIOBLineItemDetailService from '../../../Services/OutsourcedIOBLineItemDetailService';
import OutsourcedIOBLineItemDetailItem from '../../../Domain/OutsourcedIOBLineItemDetailItem';
import OfficeService from '../../../Services/OfficeService';

class EditOutsourcedIOBLineItemDetailWindowDescription extends React.Component {
  static titleForCreate = 'Create Outsourced IOB Line Item Detail';
  static titleForEdit = 'Edit Outsourced IOB Line Item Detail';

  static itemType = OutsourcedIOBLineItemDetailItem;

  static serviceFunction = (editedItem) => OutsourcedIOBLineItemDetailService.Upsert(editedItem);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OutsourcedUserId',
          label: 'Outsourced User',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !!item.OutsourcedIOBLineItemDetailId,
        },
        {
          // Read-only twin of OutsourcedUserId (shown when editing instead of creating) — kept at the
          // same width so the panel does not re-flow between the create and the edit variant.
          fieldName: 'OutsourcedUserName',
          label: 'Outsourced User',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          hide: (item) => !item.OutsourcedIOBLineItemDetailId,
        },
        {
          fieldName: 'OutsourcingOfficeId',
          label: 'Work Done By',
          className: 'col-4',
          type: InputTypesEnum.OfficeSelect,
          showFilterAt: 9999,
          validityChecker: ValidityHelper.forRequiredSelectField,
          onFieldChange: EditOutsourcedIOBLineItemDetailWindowDescription.onOutsourcingOfficeChange,
          hide: (item) => !!item.TimesheetEntryId,
        },
        {
          fieldName: 'FieldworkOfficeId',
          label: 'Bill To Office',
          className: 'col-4',
          type: InputTypesEnum.OfficeSelect,
          showFilterAt: 9999,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !!item.TimesheetEntryId,
        },
        {
          fieldName: 'LineItemDetailType',
          label: 'Transaction Type',
          className: 'col-4',
          type: InputTypesEnum.Select,
          selectvalues: EditOutsourcedIOBLineItemDetailWindowDescription.getSelectValuesForLineItemType,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !!item.TimesheetEntryId,
        },
        {
          fieldName: 'FeeAmount',
          label: (item) => `Fee Amount (${item.CurrencyCode || ''})`,
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
          hide: (item) => !!item.TimesheetEntryId,
        },
        {
          fieldName: 'ApplyDate',
          label: 'Apply Date',
          className: 'col-4',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ClientId',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !!item.TimesheetEntryId,
        },
        {
          fieldName: 'ThirdPartySource',
          label: 'Third Party Source',
          className: 'col-12',
          type: InputTypesEnum.ThirdPartySourceSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ClientId,
          hide: (item) => !!item.TimesheetEntryId,
        },
        {
          fieldName: 'ClientFeeId',
          label: 'Project',
          className: 'col-12',
          type: InputTypesEnum.ActiveClientFeeSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ClientId,
          hide: (item) => (item.ThirdPartySource && item.ThirdPartySource !== 'Apollo') || !!item.TimesheetEntryId,
        },
        {
          fieldName: 'ProjectId',
          label: 'Project',
          className: 'col-12',
          type: InputTypesEnum.ActiveProjectSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ClientId,
          hide: (item) => !item.ThirdPartySource || item.ThirdPartySource === 'Apollo' || !!item.TimesheetEntryId,
        },
        {
          fieldName: 'SurveyId',
          label: 'Survey',
          className: 'col-12',
          type: InputTypesEnum.SurveySelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ThirdPartySource || !item.ClientId,
          hide: (item) => (item.ThirdPartySource && item.ThirdPartySource !== 'Apollo') || !!item.TimesheetEntryId,
        },
        {
          fieldName: 'WaveId',
          label: 'Wave',
          className: 'col-12',
          type: InputTypesEnum.WaveSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ThirdPartySource || !item.ClientId,
          hide: (item) => (item.ThirdPartySource && item.ThirdPartySource !== 'Apollo') || !!item.TimesheetEntryId,
        },
        {
          fieldName: 'TpSurveyId',
          label: 'TP Survey',
          className: 'col-12',
          type: InputTypesEnum.TpSurveySelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ClientId,
          hide: (item) => !item.ThirdPartySource || item.ThirdPartySource === 'Apollo' || !!item.TimesheetEntryId,
        },
        {
          fieldName: 'TpWaveId',
          label: 'TP Wave',
          className: 'col-12',
          type: InputTypesEnum.TpWaveSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => !item.ClientId,
          hide: (item) => !item.ThirdPartySource || item.ThirdPartySource === 'Apollo' || !!item.TimesheetEntryId,
        },
      ],
    },
  ];

  static getSelectValuesForLineItemType() {
    return selectHelper.generateSelectValues([LineItemTypeEnum.Addition, LineItemTypeEnum.Deduction]);
  }

  static async onOutsourcingOfficeChange(editedItem) {
    if (editedItem.OutsourcingOfficeId) {
      const currency = await OfficeService.GetOfficeBillingCurrency(editedItem.OutsourcingOfficeId);
      editedItem.CurrencyCode = currency.currencyCode;
    } else {
      editedItem.CurrencyCode = null;
    }
  }
}

export default EditOutsourcedIOBLineItemDetailWindowDescription;
